/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { RECEIVE_RATINGS_UNIT_CODE, FETCHING_RATINGS_UNIT_CODE } from 'state/actions/ratingsState/codeStatus';
import { transpileRatingsUnitCodeData } from 'state/reducers/ratingsState/transpilers';


/* ========== ~~~~~~~~~~  CONFIG : REDUCER ~~~~~~~~~~ ========== */
//transpiler


// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = transpileRatingsUnitCodeData({});


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
const codeStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case RECEIVE_RATINGS_UNIT_CODE:
            newState.ratingsUnitCode = transpileRatingsUnitCodeData(action.data);
            return newState;
        case FETCHING_RATINGS_UNIT_CODE:
            newState.fetchingRatingsUnitCode = action.status;
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default codeStatus;
